import _ from 'lodash'
import router from '@/router/routes'

const keyList = [
  '00974c453061d7a15db14c9c24955a5d',
  '66f50e64298be91ffb48bd3037322516'
]

export function setup () {
  if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_ENV !== 'production') {
    return null
  }
  const jsLoaderList = _.map(keyList, (key) => new Promise((resolve, reject) => {
    if (document.getElementById(key)) {
      resolve()
    }
    const script = document.createElement('script')
    script.id = key
    script.src = `${window.location.protocol}//hm.baidu.com/hm.js?${key}`
    script.async = false
    script.onload = resolve
    script.onerror = reject
    const content = (document.head || document.body)
    content.appendChild(script)
  }))
  const hmt = []
  window._hmt = hmt
  router.beforeEach((to, from, next) => {
    const _hmt = hmt || window._hmt
    if (_hmt && to.path) {
      _hmt.push(['_trackPageview', to.fullPath])
    }
    next()
  })
  return Promise.all(jsLoaderList)
}
